<template>
  <div>
    <div
      class="youtube-btn-wrap">
      <div
        class="youtube-search-wrap"
        style="margin-bottom: 22px;">
        <input
          v-model="keyword"
          class="youtube-search"
          placeholder="楽曲名、ISRC"
          type="search"
          @search="onClickedSearch('', $event)"
          @keydown.prevent.enter="onClickedSearch('enter', $event)">
        <a
          class="c-btn c-btn--search"
          @click.prevent="onClickedSearch('',$event)">
          <img src="/img/common/icon-search.png" />検索
        </a>
      </div>
    </div>
    <asset-table
      v-if="assets.length > 0"
      :items="assets"
      @row-clicked="onRowClicked" />
    <div
      v-else-if="errorMessage"
      class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import YouTubeAssetsAssetTable from './AssetTable'

export default {
  name: 'YouTubeAssetsSearch',
  components: {
    AssetTable: YouTubeAssetsAssetTable,
  },
  props: {
    preSearchKeyword: {
      type: String,
      default: '',
    },
    videoId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      keyword: '',
      assets: [],
      errorMessage: null,
    }
  },
  watch: {
    preSearchKeyword(value) {
      this.keyword = value
      this.fetchItems(this.keyword)
    },
  },
  mounted() {
    if (this.preSearchKeyword) {
      this.keyword = this.preSearchKeyword
    }
    this.fetchItems(this.keyword)
  },
  methods: {
    onClickedSearch(type, event) {
      if (type === 'enter' && event.keyCode !== 13) {
        return
      }
      this.fetchItems(this.keyword, true)
    },
    async fetchItems(keyword, reload = false) {
      this.errorMessage = null
      this.assets = []
      this.error = null
      if (reload) {
        this.$emit('on-change-query', { keyword })
      }
      try {
        // 検索結果を取得
        const { data } = await window.axios.get('/api/client/youtube/assets/search', {
          params: {
            keyword,
            video_id: this.videoId,
          },
        })
        this.assets = data
      } catch (e) {
        const { response } = e
        const { status } = response
        if (status === 404) {
          this.assets = []
          this.errorMessage = '検索結果が見つかりませんでした'
        }
        this.error = e
      }
    },
    onRowClicked(id) {
      this.$emit('on-row-clicked', id)
    },
  },
}
</script>

<style scoped>
.error-message {
  color: #ff0000;
  font-size: 16px;
  margin: 20px auto 120px 20px;
  text-align: left;
}
</style>
